//Set a user's initial email if it cannot be retrieved from Facebook.
function SetInitialEmailSvc($resource) {
    'ngInject';
    var odataUrl = TFL_Base_Url + 'member/email/setInitialEmail'
    return $resource(odataUrl, {}, {
        post: {
            method: 'POST',
            params: {
                InitialEmailModel: '@InitialEmailModel',
            },
            isArray: false
        }
    });
};

export default {
    name: "SetInitialEmailSvc",
    fn: SetInitialEmailSvc
}